/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	HubSpotLinkStorePathParams,
	HubSpotLinkStoreRequest,
	HubSpotLinkStoreResponse,
} from '../types/HubSpotLinkStore'

/**
 * POST /:organisation/hubspot
 * @see backend/nexus/modules/SupplyChain/Http/Controllers/HubSpotLinkController.php HubSpotLinkController::store
 */
export async function hubSpotLinkStore(
	organisation: HubSpotLinkStorePathParams['organisation'],
	data: HubSpotLinkStoreRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<HubSpotLinkStoreResponse>> {
	return axiosInstance.post(`/${organisation}/hubspot`, data, config)
}
